enum OnBranchUpdateCaller {
	Init = "init",
	Checkout = "checkout",
	MergeRequest = "merge-request",
	DiscardNoReset = "discard-no-reset",
}

export default OnBranchUpdateCaller;
